export const contacts = [
    {
        name: "Anastasija Belajeva",
        phone: "+371 28830704",
        email: "Anastasija.belajeva@incosys.net"
    },
    {
        name: "Guido Philipps",
        phone: "+371 26499543",
        email: "trading@incosys.net"
    },
]


export const aboutUs = {
    name: "Incosys Trading SIA",
    address: `Siguldas iela 21-11 Ventspils, LV-3602`,
    regNr: "40203413003",
    vatNr: "LV40203413003",
    phone: "+371 26499543",
    email: "info@incosys.net"
}